const schemas = require('./schemas');

module.exports = schemas;
